export default __webpack_public_path__ + "static/media/right-scroll-icon.fb517e13.svg";